import { CHAINS } from 'consts';
import { Address } from 'viem';

export const INITIAL_FIXED_TOKENS: Record<number, Address[]> = {
  [CHAINS.ethereum.id]: [
    '0x0000000000000000000000000000000000000000', // ETH
    '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', // WETH
    '0xdac17f958d2ee523a2206206994597c13d831ec7', // USDT
    '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', // USDC
    '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599', // WBTC
    '0x6b175474e89094c44da98b954eedeac495271d0f', // DAI
  ],
  [CHAINS.bsc.id]: [
    '0x0000000000000000000000000000000000000000', // BNB
    '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', // WBNB
    '0x55d398326f99059ff775485246999027b3197955', // USDT
    '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d', // USDC
    '0x2170ed0880ac9a755fd29b2688956bd959f933f8', // WETH
    '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c', // BTCB
  ],
  [CHAINS.cronos.id]: [
    '0x0000000000000000000000000000000000000000', // CRO
    '0x5c7f8a570d578ed84e63fdfa7b1ee72deae1ae23', // WCRO
    '0x66e428c3f67a68878562e79a0234c1f83c208770', // USDT
    '0xc21223249ca28397b4b6541dffaecc539bff0c59', // USDC
    '0x062e66477faf219f25d27dced647bf57c3107d52', // WBTC
    '0xe44fd7fcb2b1581822d0c862b68222998a0c299a', // WETH
  ],
  [CHAINS.base.id]: [
    '0x0000000000000000000000000000000000000000', // ETH
    '0x4200000000000000000000000000000000000006', // WETH
    '0x50c5725949a6f0c72e6c4a641f24049a917db0cb', // DAI
    '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca', // USDbC
    '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913', // USDC
    '0x532f27101965dd16442e59d40670faf5ebb142e4', // BRETT
  ],
  [CHAINS.linea.id]: [
    '0x0000000000000000000000000000000000000000', // ETH
    '0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f', // WETH
    '0xa219439258ca9da29e9cc4ce5596924745e12b93', // USDT
    '0x176211869ca2b568f2a7d4ee941e073a821ee1ff', // USDC
    '0x2416092f143378750bb29b79ed961ab195cceea5', // ezETH
    '0x1bf74c010e6320bab11e2e5a532b5ac15e0b8aa6', // weETH
    '0x3aab2285ddcddad8edf438c1bab47e1a9d05a9b4', // WBTC
    '0x1789e0043623282d5dcc7f213d703c6d8bafbb04', // LINEA
  ],
  [CHAINS.scroll.id]: [
    '0x0000000000000000000000000000000000000000', // ETH
    '0x5300000000000000000000000000000000000004', // WETH
    '0xf55bec9cafdbe8730f096aa55dad6d22d44099df', // USDT
    '0x06efdbff2a14a7c8e15944d1f4a48f9f95f663a4', // USDC
    '0x3c1bca5a656e69edcd0d4e36bebb3fcdaca60cf1', // WBTC
    '0xca77eb3fefe3725dc33bccb54edefc3d9f764f97', // DAI
  ],
  [CHAINS.manta.id]: [
    '0x0000000000000000000000000000000000000000', // ETH
    '0x0dc808adce2099a9f62aa87d9670745aba741746', // WETH
    '0xf417f5a458ec102b90352f697d6e2ac3a3d2851f', // USDT
    '0xb73603c5d87fa094b7314c74ace2e64d165016fb', // USDC
  ],
  [CHAINS.blast.id]: [
    '0x0000000000000000000000000000000000000000', // ETH
    '0x4300000000000000000000000000000000000004', // WETH
    '0x4300000000000000000000000000000000000003', // USDB
    '0x2416092f143378750bb29b79ed961ab195cceea5', // ezETH
  ],
  [CHAINS.metis.id]: [
    '0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000', // METIS
    '0x75cb093e4d61d2a2e65d8e0bbb01de8d89b53481', // WMETIS
    '0xea32a96608495e54156ae48931a7c20f0dcc1a21', // m.USDC
    '0xbb06dca3ae6887fabf931640f67cab3e3a16f4dc', // m.USDT
    '0xa5b55ab1daf0f8e1efc0eb1931a957fd89b918f4', // WBTC
  ],
  [CHAINS.xLayer.id]: [
    '0x0000000000000000000000000000000000000000', // OKB
    '0xe538905cf8410324e03a5a23c1c177a474d59b2b', // WOKB
    '0x1e4a5963abfd975d8c9021ce480b42188849d41d', // USDT
    '0x74b7f16337b8972027f6196a17a631ac6de26d22', // USDC
    '0x5a77f1443d16ee5761d310e38b62f77f726bc71c', // WETH
  ],
  [CHAINS.arbitrum.id]: [
    '0x0000000000000000000000000000000000000000', // ETH
    '0x82af49447d8a07e3bd95bd0d56f35241523fbab1', // WETH
    '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9', // USDT
    '0xaf88d065e77c8cc2239327c5edb3a432268e5831', // USDC
    '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f', // WBTC
  ],
  [CHAINS.zetachain.id]: [
    '0x0000000000000000000000000000000000000000', // ZETA
    '0x5f0b1a82749cb4e2278ec87f8bf6b618dc71a8bf', // WZETA
    '0x7c8dda80bbbe1254a7aacf3219ebe1481c6e01d7', // USDT.ETH
    '0x0cbe0df132a6c6b4a2974fa1b7fb953cf0cc798a', // USDC.ETH
    '0x13a0c5930c028511dc02665e7285134b6d11a5f4', // BTC.BTC
  ],
  [CHAINS.polygon.id]: [
    '0x0000000000000000000000000000000000000000', // MATIC
    '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270', // WMATIC
    '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619', // WETH
    '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', // USDT
    '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359', // USDC
    '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC.e
  ],
  [CHAINS.soneium.id]: [
    '0x0000000000000000000000000000000000000000', // ETH
    '0x4200000000000000000000000000000000000006', // WETH
    '0xba9986d2381edf1da03b0b9c1f8b00dc4aacc369', // USDC.e
    '0x3a337a6ada9d885b6ad95ec48f9b75f197b5ae35', // USDT
  ],
  [CHAINS.unit0.id]: [
    '0x0000000000000000000000000000000000000000', // UNIT0
    '0xcf43f7703d9b4e8835f977ef364b4014fa7e856e', // WUNIT0
    '0xb303d80db8415fd1d3c9fed68a52eeac9a052671', // USDT
    '0xeb19000d90f17ffbd3ad9cdb8915d928f4980fd1', // USDC
    '0x1b100de3f13e3f8bb2f66fe58c1949c32e71248b', // WETH
  ],
  [CHAINS.hyper.id]: [
    '0x0000000000000000000000000000000000000000', // HYPE
    '0x5555555555555555555555555555555555555555', // WHYPE
    '0xb8ce59fc3717ada4c02eadf9682a9e934f625ebb', // USD₮0
    '0x5748ae796ae46a4f1348a1693de4b50560485562', // LHYPE
    '0xb50a96253abdf803d85efcdce07ad8becbc52bd5', // USDHL
    '0x9fdbda0a5e284c32744d2f17ee5c74b284993463', // UBTC
    '0xbe6727b535545c67d5caa73dea54865b92cf7907', // UETH
  ],
  [CHAINS.zeroG.id]: [
    '0x0000000000000000000000000000000000000000', // 0G
    '0x1f3aa82227281ca364bfb3d253b0f1af1da6473e', // USDC.e
    '0x1cd0690ff9a693f5ef2dd976660a8dafc81a109c', // W0G
    '0x564770837ef8bbf077cfe54e5f6106538c815b22', // WETH
    '0x7bbc63d01ca42491c3e084c941c3e86e55951404', // st0G
  ],
  [CHAINS.devnet.id]: [],
};
